import type { SVGProps } from "react";

/**
 * Six-dot drag grip from the form-builder field-type rows (Figma 60:18166).
 * Two columns of three filled dots inside a 20px icon.
 */
export function DragDotsIcon({
	className,
	...props
}: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 20 20"
			fill="currentColor"
			aria-hidden
			className={className}
			{...props}
		>
			<circle cx="6.5" cy="4" r="1.5" />
			<circle cx="12.5" cy="4" r="1.5" />
			<circle cx="6.5" cy="10" r="1.5" />
			<circle cx="12.5" cy="10" r="1.5" />
			<circle cx="6.5" cy="16" r="1.5" />
			<circle cx="12.5" cy="16" r="1.5" />
		</svg>
	);
}
